import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    COLOR
} from '../../../business-const/Color/Color'

import {
    arrayAte
} from '../../../business-components/Array/Array'

import {
    GridContainer,
    GridItem3,
    GridItem4,
    GridItem11,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    ButtonVerTabelaEvolucaoValorResgate,
    ButtonVerTabelaEvolucaoCS,
    ButtonVerTabelaEvolucaoCancelamentoApolice,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import instituicaoFinanceiraList from '../../../business-rules/List/instituicaoFinanceiraList'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadraoMd,
} from '../estudo-form/EstudoComp'

import EstudoFormTabelaEvolucaoValorResgate from '../estudo-form/EstudoFormTabelaEvolucaoValorResgate'

import EstudoFormTabelaEvolucaoCS from '../estudo-form/EstudoFormTabelaEvolucaoCS'

import EstudoFormTabelaEvolucaoCancelamentoApolice from '../estudo-form/EstudoFormTabelaEvolucaoCancelamentoApolice'



const TabelaEvolucaoValorResgateChart = ( { values, estudo, estrategiasFinanceirasTabelaEvolucaoValorResgate, report,
    tabelaEvolucaoValorResgate } ) => {

    const TabelaEvolucaoValorResgate = () => {

        const series = []

        const paletaCoresEspecifica = []

        const valorCS = []
        const valorPremioAnualizadoAcumulado = []
        const valorResgate = []

        const indAte =
            values.anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao
                ?
                   values.anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao - 1
                :
                    null

        

        let categories = [...estudo.current.graficoIdades]

        if (estrategiasFinanceirasTabelaEvolucaoValorResgate.familiar !== HARDCODE.idFamiliarCliente) {

            const idadeDataSimulacao =
                pesquisaList(familiaresList(values),
                    estrategiasFinanceirasTabelaEvolucaoValorResgate.familiar).idadeDataSimulacao

            categories?.forEach( (linha, ind) => {

                categories[ind] += idadeDataSimulacao - values.idadeDataSimulacaoCliente
            })
        }

        categories = arrayAte(categories, indAte)
        const categories2 = arrayAte(estudo.current.graficoAnos, indAte)



        estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate?.forEach( (linha, ind) => {
            
            //if (ind === 0 && linha.ano !== 0) {
            if (ind === 0 && linha.idade !== categories[0]) {
                valorCS.push(linha.valorCS)
                valorPremioAnualizadoAcumulado.push(linha.valorPremioAnualizadoAcumulado)
                valorResgate.push(linha.valorResgate)
            }

            valorCS.push(linha.valorCS)
            valorPremioAnualizadoAcumulado.push(linha.valorPremioAnualizadoAcumulado)
            valorResgate.push(linha.valorResgate)
        })



        series.push(
            {
                name: LABEL.capitalSegurado,
                type: 'line',
                data: arrayAte(valorCS, indAte),
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoTabelaEvolucaoValorResgateCapitalSegurado // COLOR().corChartPadraoVidaInteiraCotacao
        )



        if (valorResgate[7] > 0) {
            
            series.push(
                {
                    name: LABEL.valorResgate,
                    type: 'line',
                    data: arrayAte(valorResgate, indAte),
                },
            )

            paletaCoresEspecifica.push(
                COLOR().corChartPadraoTabelaEvolucaoValorResgateValorResgate // COLOR().corChartPadraoTabelaEvolucaoValorResgate
            )
        }



        series.push(
            {
                name: LABEL.valorPremioAnualizadoAcumulado,
                type: 'line',
                data: arrayAte(valorPremioAnualizadoAcumulado, indAte),
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoTabelaEvolucaoValorResgatePremioAnualizadoAcumulado // COLOR().corChartPadraoValorPremioAnualizadoAcumulado
        )



        const SvgLogoInstituicaoFinanceira =
            pesquisaList(instituicaoFinanceiraList, estrategiasFinanceirasTabelaEvolucaoValorResgate.seguradora).SvgLogo



        return (
            <>
                <GridContainer
                    //className={'mb-5' + (report ? ''/*' mt--5'*/ : values.modoApresentacao ? ' mt--0' : '')}
                >
                    <GridItem4
                        className=''//'ml--8'
                    >
                        {SvgLogoInstituicaoFinanceira && (
                            <SvgLogoInstituicaoFinanceira/>
                        )}
                    </GridItem4>
                </GridContainer>

                <GridContainer>
                    <GridItem11
                        className={'ml-10 ' + (report ? '' : 'mt--5')}//mt--22' //mt--8
                    >
                        <ChartPadrao
                            titleText={''}
                            type={'line'}
                            series={series}
                            height={300}
                            stacked={false}
                            categories={categories}
                            categories2={categories2}
                            paletaCores={paletaCoresEspecifica}
                            dataLabelsEnabled={true}
                            dataLabelsEnabledReport={true}
                            dataLabelsType='IdadeIndex'
                            dataLabelsDestaque={
                                estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate.length >= 5 &&
                                estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate[4].bold
                                    ?
                                        [categories[5]]
                                    :
                                        ''
                            /*[values.idadeDataSimulacaoCliente + 10]*/}
                            notInverseOrder={false}
                            //legendFixedEnabled={true}
                            toolTipX={true}
                            toolTipXTotal={false}
                            report={report}
                            formatoReport={values.formatoReport}
                            fillOpacity={0.8}
                        />
                    </GridItem11>
                </GridContainer>

                {!report && !values.modoApresentacao && (
                    <GridContainer
                        className="justify-end"
                    >
                        {!values.exibirTabelaEvolucaoCS && !values.exibirTabelaEvolucaoCancelamentoApolice && (
                            <GridItem3>
                                <CustomizedDialogsPopup
                                    maxWidth='lg'
                                    popupTitle={LABEL.tabelaEvolucaoValorResgate}
                                    PopupButton={ButtonVerTabelaEvolucaoValorResgate}
                                    popupComponent={
                                        <EstudoFormTabelaEvolucaoValorResgate
                                            values={values}
                                            estudo={estudo}
                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={
                                                estrategiasFinanceirasTabelaEvolucaoValorResgate
                                            }
                                            report={false}
                                        />
                                    }
                                />
                            </GridItem3>
                        )}
                        {values.exibirTabelaEvolucaoCS && (
                            <GridItem3>
                                <CustomizedDialogsPopup
                                    maxWidth='lg'
                                    popupTitle={LABEL.tabelaEvolucaoCS}
                                    PopupButton={ButtonVerTabelaEvolucaoCS}
                                    popupComponent={
                                        <EstudoFormTabelaEvolucaoCS
                                            values={values}
                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={
                                                estrategiasFinanceirasTabelaEvolucaoValorResgate
                                            }
                                            report={false}
                                        />
                                    }
                                />
                            </GridItem3>
                        )}
                        {values.exibirTabelaEvolucaoCancelamentoApolice && (
                            <GridItem3>
                                <CustomizedDialogsPopup
                                    maxWidth='lg'
                                    popupTitle={LABEL.tabelaEvolucaoCancelamentoApolice}
                                    PopupButton={ButtonVerTabelaEvolucaoCancelamentoApolice}
                                    popupComponent={
                                         <EstudoFormTabelaEvolucaoCancelamentoApolice
                                            values={values}
                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={
                                                estrategiasFinanceirasTabelaEvolucaoValorResgate
                                            }
                                            report={false}
                                        />
                                    }
                                />
                            </GridItem3>
                        )}
                    </GridContainer>
                )}
            </>
        )
    }

    return (
        report// || tabelaEvolucaoValorResgate
            ?
                <TabelaEvolucaoValorResgate/>
            :
                <CardGridEstudoPadraoMd
                    label={
                        !relatorioModoApresentacao(values)
                            ?
                                LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/ + ': ' +
                                    estrategiasFinanceirasTabelaEvolucaoValorResgate.nomeFamiliar
                            :
                                HARDCODE.modoApresentacaoRelatorio
                    }
                    component={
                        <TabelaEvolucaoValorResgate/>
                    }
                    overflowX={false}
                    modoApresentacao={values.modoApresentacao}
                />
    )
}

export default TabelaEvolucaoValorResgateChart